module.exports = __webpack_public_path__ + "img/sankaku_8_red.218c0a3f.png";